import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../shared/constants';

export const useHandleGoToCheckout = (store) => {
    const navigate = useNavigate();
    return ({ cartId, checkoutKey, isBuyNow = false }) => {
        return navigate(ROUTE_PATHS.preCheckout(), {
            state: {
                cartId,
                checkoutKey,
                cashBack: store.marketplaceStore.cashBack,
                previousCashBack: store.marketplaceStore.previousCashBack,
                isBuyNow
            }
        });
    };
};
